//  actions
import TYPES from './types'

//  initialState
import initialState from './initialState'

// Model
import model from './model'

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.PRODUCTS.FETCH.REQUEST:
      return model.loading(state, action.payload)
    case TYPES.PRODUCTS.FETCH.SUCCEEDED:
      return model.capturedResponse(state, action.payload)
    case TYPES.PRODUCTS.FETCH.FAILED:
      return model.error(state, action.payload)
    default:
      return state
  }
}
